"use strict";
exports.__esModule = true;
var ESCAPE_KEY_CODE = 27;
exports.ESCAPE_KEY_CODE = ESCAPE_KEY_CODE;
